import { RightOutlined } from "@ant-design/icons"
import { Badge, Button, Tooltip } from "antd"

import { useApiContext } from "#contexts/ApiContextProvider"

// Floating opener for the print queue when hidden
const GlobalPrintQueueOpener = () => {
  const { isBatchModalOpen, openBatchModal, printItems } = useApiContext()
  const numActive = printItems.filter((p) => p.status !== "printed").length
  const hasErrors = !!printItems.filter((p) => p.status === "error").length

  if (isBatchModalOpen || printItems.length === 0) return null

  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        bottom: 24,
        zIndex: 1000,
      }}
    >
      <Tooltip title="Open print queue">
        <Badge
          count={hasErrors ? "!" : numActive}
          color={hasErrors ? "red" : "green"}
          overflowCount={99}
          size="small"
        >
          <Button
            type="primary"
            shape="round"
            icon={<RightOutlined />}
            iconPosition="end"
            onClick={openBatchModal}
          >
            Print Queue
          </Button>
        </Badge>
      </Tooltip>
    </div>
  )
}

export default GlobalPrintQueueOpener
